import { Link } from "react-router-dom";
import { useUserXp } from "../../hooks/useUserXp";
import styles from "./header.module.scss";

export default function LevelBadge() {
    const { status, progress, hasProgress } = useUserXp();
    if (status === "signed-out") return null;
    const hasLevel = hasProgress;
    const label = hasLevel ? `Level ${progress.level}` : "Your level";
    return <Link to="/profile" className={`${styles.levelBadge}${hasLevel ? ` ${styles.levelBadgeEarned}` : ""}`}
        aria-label={hasLevel ? `Learning level ${progress.level}, ${progress.xp} XP. View profile` : "View your learning level on your profile"}
        aria-busy={status === "loading" ? "true" : undefined}
        title={hasLevel ? `${progress.xp} XP` : undefined}>
        <span>{label}</span>
        {status === "loading" && <span className={styles.levelSpinner} aria-hidden="true" />}
    </Link>;
}
